<template>
  <div class="container">
    <div class="tab-list">
      <div @click="goList" class="category-box">
        <span class="menu-text">全部药品分类</span>
        <!-- 二级菜单 -->
        <div class="menu-list" v-if="mainCategoryList.length > 0">
          <ul class="ul-box" @mouseleave="hideMenu" ref="ulBox">
            <li
              v-for="(item, index) of mainCategoryList"
              :key="item.id"
              @mouseenter="enterMenu(index)"
              :class="active === index ? 'active' : ''"
              @click.stop=""
            >
              <div class="img">
                <img :src="item.pic" alt="" />
              </div>
              {{ item.cate_name }}
              <!-- 第三级菜单 -->
              <div class="third-list" v-if="active === index">
                <div class="title">{{ item.cate_name }}</div>
                <div class="tip-list">
                  <div
                    v-for="val of thirdList"
                    :key="val.id"
                    @click.stop="thirdCategory(item.id, val.id)"
                    class="tip"
                  >
                    {{ val.cate_name }}
                  </div>
                </div>
              </div>
            </li>
            <li
              @mouseenter="enterMenu(11)"
              :class="active === 11 ? 'active' : ''"
              @click.stop=""
            >
              <div class="img-add">
                <Icon type="plus-round" class="add"></Icon>
              </div>
              更多科室
              <!-- 第三级菜单 -->
              <div class="third-list" v-if="active === 11">
                <div
                  class="more-list"
                  v-for="item of mainCategoryMore"
                  :key="item.id"
                >
                  <div class="title">{{ item.cate_name }}</div>
                  <div class="tip-list">
                    <div
                      v-for="val of item.children"
                      :key="val.id"
                      @click.stop="thirdCategory(item.id, val.id)"
                      class="tip"
                    >
                      {{ val.cate_name }}
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="other-meun">
        <div><router-link to="/" tag="div">首页</router-link></div>
        <div @click="goToNew">行业资讯</div>
        <!-- <div @click="buyDrug">药品求购</div> -->
        <div @click="sign">每日签到</div>
        <div @click="toProcess">乐托品流程</div>
      </div>
    </div>
    <SignIn ref="signIn"></SignIn>
  </div>
</template>

<script>
import SignIn from "@components/pc/nav/SignIn";
import { getCategory } from "@api/public";
export default {
  name: "TabBar",
  components: {
    SignIn
  },
  data() {
    return {
      mainCategory: [],
      menuMask: false,
      active: "",
      thirdList: []
    };
  },
  computed: {
    mainCategoryList() {
      return this.mainCategory.filter((item, index) => {
        if (index < 10) return true;
      });
    },
    mainCategoryMore() {
      return this.mainCategory.filter((item, index) => {
        if (index > 10) return true;
      });
    }
  },
  created() {
    this.getCategoryList();
  },
  methods: {
    goList() {
      this.$router.push({
        path: "/goodsCategory"
      });
    },
    goToNew() {
      this.$router.push({
        path: "/news"
      });
    },
    toProcess() {
      this.$router.push({
        path: "/process"
      });
    },
    buyDrug() {
      this.$router.push({
        path: "/buyDrug"
      });
    },
    sign() {
      this.$refs.signIn.sign();
    },
    getCategoryList() {
      getCategory().then(res => {
        this.mainCategory = res.data;
      });
    },
    showMenu() {
      this.menuMask = true;
    },
    hideMenu() {
      this.$refs.ulBox.style.width = "200px";
      this.menuMask = false;
      this.active = "";
    },
    enterMenu(index) {
      this.menuMask = true;
      this.$refs.ulBox.style.width = "800px";
      this.active = index;
      this.thirdList = this.mainCategory[index].children;
    },
    thirdCategory(mainId, secondId) {
      this.$router.push({
        name: "GoodsList",
        params: {
          mainId: mainId,
          secondId: secondId
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
div.container
  background #fff
  border-bottom 2px solid #3284dd
  .tab-list
    width 1200px
    margin 0 auto
    display flex
    height 40px
    line-height 40px
    font-size 16px
    position relative
    .category-box
      position relative
      width 200px
      background #1880f4
      color #fff
      font-size 16px
      font-weight 400
      border-right 0
      text-align center
      cursor pointer
      .menu-list
        position absolute
        z-index: 100;
        width 200px
        background #1880f4
        color #fff
        font-size 16px
        text-align left
        .ul-box
          height 450px
          li
            font-size 15px
            line-height 40px
            font-weight normal
            padding-left 16px
            border-bottom 1px solid rgba(255, 255, 255, 0.3)
            &:last-child
              border-bottom 1px solid #1880f4
            &.active
              background #fff
              color #1880f4
              &:first-child
                transform translateY(2px)
            .img
              display inline-block
              width 20px
              height 20px
              transform translateY(5px)
              margin-right 5px
              img
                width 100%
                height 100%
            .img-add
              display inline-block
              transform translateX(1px) translateY(2px)
              margin-right 2px
              .add
                color #86b8e9
                font-size 22px
          .third-list
            position absolute
            background #fff
            top 2px
            left 200px
            width 600px
            height 450px
            padding 15px 30px
            border-right 1px solid #1880f4
            border-bottom 2px solid #1880f4
            overflow-y auto
            &::-webkit-scrollbar
              width 7px
            &::-webkit-scrollbar-thumb
              background #607d8b
              -webkit-border-radius: 10px;
              -moz-border-radius: 10px;
              border-radius: 10px;
            .title
              font-size 14px
              color #333
              font-weight 550
              line-height 28px
              cursor auto
            .tip-list
              display flex
              flex-wrap wrap
              line-height 24px
              .tip
                font-size 13px
                color #666
                padding-right 15px
                line-height 24px
                cursor pointer
                &:hover
                  color red
            .more-list
              margin-bottom 15px

    .other-meun
      display flex
      margin-left 25px
      div
        cursor pointer
        letter-spacing: 2px
        line-height 40px
        padding 0 25px
        &:hover
          color #1880f4

    .commany
      position absolute
      width 200px
      height 410px
      background #fff
      z-index 100
      right 0
      top 60px
      text-align center
      &-title
        font-weight 550
        font-size 15px
        margin-top 10px
      &-des
        color #999
        font-size 10px
        line-height 12px
        padding-bottom 20px
        border-bottom 1px solid #ddd
      &-code
        margin-top 35px
        font-size 15px
        color #999
        line-height 34px
        .img
          margin 0 auto
          width 100px
          height 100px
          img
            width 100%
            height 100%
        .tip
          margin-top 10px
          margin-bottom 30px
      &-promise
        border-top 1px dashed #ccc
        padding-top 20px
        margin 0 20px
        img
          width 100%
          height 100%
</style>
